import React, { FC } from 'react';
import { RoomExtra, RoomExtraOption } from 'shared-types/Room';
import { Field } from 'redux-form';
import QuantityPicker from '@common/components/QuantityPicker';
import { ToggleExtra } from '@common/components/Extras/controls';
import { OptionsBox } from './OptionsBox';
import { TopRow, BottomRow, ToggleExtraWrapper } from './Options.styles';
import { controlTypes } from './controlTypes';

type OptionsProps = {
  selectedOption?: RoomExtraOption;
  isSelected?: boolean;
} & RoomExtra;

export const Options: FC<OptionsProps> = ({ isSelected, selectedOption, ...extra }) => {
  const { id } = extra;
  const maxQuantity = selectedOption?.maxQuantity || extra?.maxQuantity;
  return (
    <OptionsBox>
      <TopRow>{controlTypes(extra as RoomExtra)}</TopRow>
      <BottomRow>
        {!!maxQuantity && (
          <Field component={QuantityPicker} name={`extras.${id}.quantity`} maxValue={maxQuantity} />
        )}
        <ToggleExtraWrapper>
          <Field
            component={ToggleExtra}
            name={`extras.${id}.isSelected`}
            isDisabled={!isSelected && !selectedOption}
          />
        </ToggleExtraWrapper>
      </BottomRow>
    </OptionsBox>
  );
};
